import { enableProdMode, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';


import { environment } from './environments/environment';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AuthInterceptor } from './app/utility/services/auth.interceptor';
import { ServiceWorkerUpdate } from './app/utility/services/service-worker-update.service';
import { HomeBuyerIntegrationServiceProvider } from './app/utility/services/home-buyer/home-buyer-integration-factory.service';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { AppRoutingModule } from './app/app-routing.module';
import { provideAnimations } from '@angular/platform-browser/animations';
import { SharedAppModule } from './app/shared/shared-app.module';
import { ServiceWorkerModule } from '@angular/service-worker';
import { A11yModule } from '@angular/cdk/a11y';
import { MatDialogModule } from '@angular/material/dialog';
import { AppComponent } from './app/app.component';

const shouldEnableServiceWorker = () =>
  environment.useServiceWorker &&
  window.location.href.includes('/scp/') &&
  !window.location.href.includes('?standalone');



if (environment.production) {
  enableProdMode();
}

if (environment.buildNumber) {
  console.log(`Build number: ${environment.buildNumber}`);
}

// GIFLENS-https://media2.giphy.com/media/h26fLv6Sba1lMegpf1/200.gif
bootstrapApplication(AppComponent, {
    providers: [
        provideZoneChangeDetection(),importProvidersFrom(BrowserModule, FormsModule, AppRoutingModule, SharedAppModule, ServiceWorkerModule.register('ngsw-worker.js', {
            enabled: shouldEnableServiceWorker()
        }), A11yModule, MatDialogModule),
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        ServiceWorkerUpdate,
        HomeBuyerIntegrationServiceProvider,
        provideHttpClient(withInterceptorsFromDi()),
        provideAnimations()
    ]
})
  .catch(err => console.error(err));
